import { ApiResult } from "~/models/ApiResult";
import { type AxiosResponse } from "axios";
import { BaseService } from "./BaseService";
import type { ContactDtoForApi } from "~/models/common/ContactDtoForApi";
import type { ContractInfoResponse } from "~/models/common/ContractInfoResponse";
import type { CategoryDto } from "~/models/common/CategoryDto";
import { GetContractsByCategoryQuery, GetFaqsRequest, GetFaqsResponse, GetProductDevelopersRequest, GetProductDevelopersResponse, GetSeoContentRequest, GetSeoContentResponse, GetProductDevelopersAllQuery } from "~/models/common/GetSeoContent";


export class CommonService extends BaseService {
  constructor() {
    super("Common");
  }
  Add(body: ContactDtoForApi): Promise<AxiosResponse<ApiResult<Array<any>>>> {
    return this.client.Post<ApiResult<any>>(`${this.baseUrl}/AddContact`, body);
  }
  GetAllContract(): Promise<AxiosResponse<ApiResult<ContractInfoResponse>>> {
    return this.client.Get<ApiResult<ContractInfoResponse>>(`${this.baseUrl}/GetAllContract`)
  }
  GetContractsByCategory(query: GetContractsByCategoryQuery): Promise<AxiosResponse<ApiResult<CategoryDto>>> {
    return this.client.Get<ApiResult<CategoryDto>>(`${this.baseUrl}/GetContractsByCategory`, query)
  }
  GetProvinceAll(): Promise<AxiosResponse<ApiResult<Array<any>>>> {
    return this.client.Get<ApiResult<any>>(`${this.baseUrl}/GetProvinceAll`)
  }
  GetProductDevelopersAll(query: GetProductDevelopersAllQuery): Promise<AxiosResponse<ApiResult<Array<any>>>> {
    return this.client.Get<ApiResult<any>>(`${this.baseUrl}/GetProductDevelopers`, query)
  }
  GetDistrictAll(query: { provinceId: number }): Promise<AxiosResponse<ApiResult<Array<any>>>> {
    return this.client.Get<ApiResult<any>>(`${this.baseUrl}/GetDistrictAll`, query)
  }
  GetSeoContent(query: GetSeoContentRequest): Promise<AxiosResponse<ApiResult<GetSeoContentRequest>>> {
    return this.client.Get<ApiResult<GetSeoContentResponse>>(`${this.baseUrl}/GetSeoContent`, query)
  }
  GetFaqs(query: GetFaqsRequest): Promise<AxiosResponse<ApiResult<GetFaqsRequest>>> {
    return this.client.Get<ApiResult<GetFaqsResponse>>(`${this.baseUrl}/GetFaqs`, query)
  }
  GetSiteMap(): Promise<AxiosResponse<ApiResult<any>>> {
    return this.client.Get<ApiResult<any>>(`${this.baseUrl}/GetSiteMap`)
  }
  GetProductDevelopers(query: GetProductDevelopersRequest): Promise<AxiosResponse<ApiResult<GetProductDevelopersResponse>>> {
    return this.client.Get<ApiResult<GetProductDevelopersResponse>>(`${this.baseUrl}/GetProductDevelopers`, query)
  }
}
